// Copyright (c) Move Closer 2022.

import gql from 'graphql-tag'

import { QueryRegistry } from '../../../contexts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const sharedQueries: QueryRegistry = {
  countryQuery: {
    type: 'query',
    query: gql`
    query {
        countries {
          id
          two_letter_abbreviation
          three_letter_abbreviation
          full_name_locale
          full_name_english
          available_regions {
              id
              code
              name
          }
        }
      }
    `,
    meta: {
      noAuth: true
    }
  }
}
